angular.module('EdxFtue', []);
